
import { defineComponent } from 'vue';
import { modFramesComposition } from '../../services';

export default defineComponent({
	props: {
		datum: {
			type: Array,
			required: true,
		},
		ready: {
			type: Boolean,
			default: false,
		}
	},
	setup (props) {
		return { ...modFramesComposition(props) }
	},
})
